<template>
  <v-layout fill-height column>
    <div class="question" v-html="title"></div>
    <div class="answer">
      <Textarea
          :height="100"
          :readonly="true"
          :value="description[0]"
          class="mb-4"
      />
      <Textarea
          :height="100"
          :readonly="true"
          :value="description[1]"
      />
    </div>
    <FooterBtnsNext @before="$emit('before')" @next="$emit('next')" :current="current" :total="total"
                    :disabledNext="disabledNext"/>
  </v-layout>
</template>
<script>
import Textarea from "@/components/forms/Textarea"
import FooterBtnsNext from "@/components/btns/FooterBtnsNext"

export default {
  props: {
    current: Number,
    total: Number,
  },
  data: () => ({
    title: '그 때 들었던 생각은 무엇인가요?',
    description: ['내용내용내용내용내용내용내용내용내용내용내용내용내용내용내용내용내용', '내용내용내용내용내용내용내용내용내용내용내용내용내용내용']
  }),
  components: {
    Textarea,
    FooterBtnsNext,
  },
}
</script>
